"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserConditionsPrint = void 0;
const mithril_1 = __importDefault(require("mithril"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const snarkdown_1 = __importDefault(require("snarkdown"));
const app_1 = require("../../../app");
const client_1 = require("../../../model/client");
const helpers_1 = require("../../../utils/helpers");
const form_for_1 = require("../../../widgets/form_for");
const user_condition_md_1 = __importDefault(require("./user_condition.md"));
exports.UserConditionsPrint = {
    client: {},
    loading: true,
    fetch(id) {
        this.loading = true;
        client_1.ClientProvider.show(id).then((data) => {
            this.client = data;
            this.loading = false;
        });
    },
    oncreate(node) {
        let id = node.attrs.client_id;
        this.fetch(id);
    },
    link(id) {
        return `#/clients/${id}/print`;
    },
    renderPrintToolbox() {
        return (0, mithril_1.default)("div", { class: "print-toolbox" }, (0, mithril_1.default)("button", {
            class: "button",
            onclick: () => { print(); }
        }, (0, helpers_1.iconSpan)("fa-print"), (0, mithril_1.default)("span", "Imprimer")));
    },
    renderTopCapsule() {
        return [
            (0, mithril_1.default)("img", { src: "/logo_contract.jpg" }),
            (0, form_for_1.columns)((0, mithril_1.default)("div", (0, mithril_1.default)("div", (0, mithril_1.default)("strong", "Centre SESAME")), (0, mithril_1.default)("div", "39, bd de Magenta, 75010 PARIS"), (0, mithril_1.default)("div", (0, mithril_1.default)("a", { href: "http://www.centresesame.com" }, "www.centresesame.com")), (0, mithril_1.default)("div", "01 40 35 41 86"), (0, mithril_1.default)("div", (0, mithril_1.default)("a", { href: "mailto:clientsesame@gmail.com" }, "clientsesame@gmail.com"))), (0, mithril_1.default)("div", (0, mithril_1.default)("div", (0, mithril_1.default)("strong", `CLIENT N° ${this.client.id}`)), (0, mithril_1.default)("div", `${this.client.first_name} ${this.client.last_name}`), (0, mithril_1.default)("div", `CONDITIONS GÉNÉRALES DE MISE À DISPOSITION DE LOCAUX`))),
            (0, mithril_1.default)("hr")
        ];
    },
    getFullAddress() {
        return `${this.client.address}, ${this.client.postal_code} ${(this.client.city || "").toUpperCase()}`;
    },
    view(_node) {
        if (this.loading) {
            return (0, mithril_1.default)(".content.container.print-container", this.renderPrintToolbox(), (0, mithril_1.default)("div", { style: "text-align: center;" }, "Chargement..."));
        }
        else {
            const vars = {
                "FIRSTNAME": this.client.first_name,
                "LASTNAME": this.client.last_name,
                "SIRET": (0, helpers_1.ifTrue)(this.client.siret, `(Société ${this.client.company_name} - ${this.client.siret})`, ""),
                "ID": this.client.id,
                "FULLADDRESS": this.getFullAddress(),
                "EMAIL": this.client.email,
                "PHONE": [this.client.telephone, this.client.cellphone].filter(x => x && x != "").join("/"),
                "JOBTITLE": this.client.job_title,
                "LEGALSTATUS": this.client.legal_status,
                "SIGNEDAT": (0, moment_timezone_1.default)(this.client.contract_signed_at || (0, moment_timezone_1.default)()).format("DD/MM/YYYY"),
                "LOGO": "/logo_contract.jpg",
                "DOOR_CODE_BUILDING": app_1.App.getSettings("door_code_building"),
                "DOOR_CODE_BUILDING_2": app_1.App.getSettings("door_code_building_2")
            };
            let html = (0, snarkdown_1.default)(user_condition_md_1.default);
            let contract_replaced = html.replace(/\{\{[a-zA-Z0-9_]+\}\}/g, function (match) {
                let token = match.substring(2, match.length - 2);
                return vars[token];
            });
            return (0, mithril_1.default)(".content.container.print-container", this.renderPrintToolbox(), this.renderTopCapsule(), (0, mithril_1.default)("div.content", mithril_1.default.trust(contract_replaced)), (0, mithril_1.default)("footer", (0, mithril_1.default)("div", `SESAME - SARL au capital de 100 000 euros - 790 197 156 R.C.S. Paris - Siret: 790 197 156 00017`), (0, mithril_1.default)("div", `T.V.A. Intracommunautaire: FR4179019715600017 - Siège social: 39, bd de Magenta, 75010 Paris`), (0, mithril_1.default)("div", `Crédit Du Nord: FR76 3007 6020 4933 6533 0020 011`)));
        }
    }
};
